import moment from 'moment/moment'
import { apiCall } from './restclient'
import { appInsights } from './appInsights'
import { DATE_TIME_ISO_FORMAT } from './dateUtils'

const hippaEndpoint = 'api/v1/utilities/logs/access'
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function postHIPAALogMessage(requestBody) {
  // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
  apiCall(hippaEndpoint, 'POST', null, JSON.stringify(requestBody))
    .then(() => {})
    .catch((error) => {
      appInsights.trackEvent({
        name: 'HIPAA Log Error',
        properties: { Message: JSON.stringify(error) },
      })
    })
}

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const generateLoggPatientChartAccessData = ({ userId, patientId }) => ({
  Message: `Admin [${userId}] opened [${patientId}] patient chart at ${moment
    .utc(new Date())
    .format(DATE_TIME_ISO_FORMAT)}`,
  PatientId: patientId,
})

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const generateLoggVisitsAccessData = ({ userId, visitId, patientId }) => ({
  Message: `Admin [${userId}] opened [${visitId}] visit at ${moment.utc(new Date()).format(DATE_TIME_ISO_FORMAT)}`,
  PatientId: patientId,
})
// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const generateLoggIntakeFormData = ({ userId, intakeFormId, patientId }) => ({
  Message: `Admin [${userId}] opened [${intakeFormId}] intake form at ${moment
    .utc(new Date())
    .format(DATE_TIME_ISO_FORMAT)}`,
  PatientId: patientId,
})
